import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'src/app/core/auth/services/auth.service';
import { Router } from '@angular/router';

type TwoFaDialogData = {
  email: string;
  rememberMe: boolean;
  password: string;
  headerImage?: string; // you’ll pass your image path here
};

@Component({
  selector: 'aum-cli-two-factor-dialog',
  templateUrl: './two-factor-dialog.component.html',
  styleUrls: ['./two-factor-dialog.component.scss']
})
export class TwoFactorDialogComponent {
  form: FormGroup;
  isLoading = false;
  codeLength = 6;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: TwoFaDialogData,
    private dialogRef: MatDialogRef<TwoFactorDialogComponent>,
    private fb: FormBuilder,
    private auth: AuthService,
    private router: Router
  ) {
    this.form = this.fb.group({
      code: [
        '',
        [
          Validators.required,
          Validators.pattern('^[0-9]{6}$'),
          Validators.maxLength(this.codeLength)
        ]
      ]
    });
  }

  submit(): void {
    if (this.form.invalid || this.isLoading) return;
    this.isLoading = true;

    const code = this.form.value.code;
    this.auth
      .loginWithTwoFactorCode(this.data.email, this.data.password, code, this.data.rememberMe)
      .subscribe({
        next: auth => {
          this.isLoading = false;
          // finish normal login flow
          this.auth.setSession(auth.access_token, auth.refresh_token);
          this.dialogRef.close(true);
          this.router.navigate(['/'], { replaceUrl: true });
        },
        error: () => {
          this.isLoading = false;
          // show a tiny shake by toggling an error class
          this.form.get('code')?.setErrors({ invalid: true });
        }
      });
  }

  close(): void {
    this.dialogRef.close(false);
  }
}
